import { render, staticRenderFns } from "./AttachmentUploadItem.vue?vue&type=template&id=7b08019a&"
import script from "./AttachmentUploadItem.vue?vue&type=script&lang=ts&"
export * from "./AttachmentUploadItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports